// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2x9x_","title":"FrontImage_title__19drZ"};